import type { ApiRoute, NoBody, NoQueryParams } from "../../../api"
import type { SalesActivitySaleAndDeliveryView } from "./SalesActivitySaleAndDeliveryView"

export interface GetSaleAndDeliveryPathParams {
	inventoryId: string
}

export const getSaleAndDeliveryRoute: ApiRoute<
	GetSaleAndDeliveryPathParams,
	NoQueryParams,
	NoBody,
	SalesActivitySaleAndDeliveryView
> = {
	buildUrl: (params) => `vehicles/${params.inventoryId}/sale-and-delivery`,
	method: "get",
	path: "/vehicles/:inventoryId/sale-and-delivery",
}
